var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg394261031540882610(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.714 11.297a1.02 1.02 0 00-1.429 0l-8.999 8.976a1.008 1.008 0 101.428 1.426L16 13.436l8.285 8.264a1.012 1.012 0 001.429 0 1.008 1.008 0 000-1.426l-9-8.977z",
    fill: "#121313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg394261031540882610);
export default __webpack_public_path__ + "static/media/394261031540882610.bd9f0a370c00a6fc8281886a668bf6a5.svg";
export { ForwardRef as ReactComponent };